import React from 'react';

export const ChargingStatLogo = ({ width = '18', height = '18', fill = 'var(--icon-color-base)' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4.125H6C3.87868 4.125 2.81802 4.125 2.15901 4.78401C1.5 5.44302 1.5 6.50368 1.5 8.625V11.25C1.5 13.3713 1.5 14.4319 2.15901 15.091C2.81802 15.75 3.87868 15.75 6 15.75H12C14.1213 15.75 15.1819 15.75 15.841 15.091C16.5 14.4319 16.5 13.3713 16.5 11.25V8.625C16.5 6.50368 16.5 5.44302 15.841 4.78401C15.1819 4.125 14.1213 4.125 12 4.125Z"
        stroke={fill}
        stroke-width="1.5"
      />
      <path
        d="M9.375 6.75L7.5 9.75H10.5L8.625 12.75"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.75 4.125V3.5625C6.75 3.03583 6.75 2.77249 6.6236 2.58332C6.56888 2.50143 6.49857 2.43112 6.41668 2.3764C6.22751 2.25 5.96417 2.25 5.4375 2.25C4.91083 2.25 4.64749 2.25 4.45832 2.3764C4.37643 2.43112 4.30612 2.50143 4.2514 2.58332C4.125 2.77249 4.125 3.03583 4.125 3.5625V4.125"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.875 4.125V3.5625C13.875 3.03583 13.875 2.77249 13.7486 2.58332C13.6939 2.50143 13.6236 2.43112 13.5417 2.3764C13.3525 2.25 13.0891 2.25 12.5625 2.25C12.0359 2.25 11.7725 2.25 11.5833 2.3764C11.5014 2.43112 11.4311 2.50143 11.3764 2.58332C11.25 2.77249 11.25 3.03583 11.25 3.5625V4.125"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
